export default __webpack_public_path__ + "static/media/Accommodation.1cf8b124.svg";